import React, {useState} from 'react';
// import PropTypes from 'prop-types';
import Dashboard from '../components/Menu/Dashboard';
import LoadingScreen from '../components/Complements/LoadingScreen';
import ValidateProcessForm from '../components/Certificates/ValidateProcessForm';
import { Grid, Typography,Dialog,DialogContent, useTheme, Icon, IconButton } from '@material-ui/core';
import { loadCaptchaEnginge, validateCaptcha } from 'react-simple-captcha';
// import moment from 'moment';
import { buttonsStyles, backgroundStyles } from '../styles/LoginTheme';
import useMediaQuery from '@material-ui/core/useMediaQuery';
// import MuiDialogTitle from '@material-ui/core/DialogTitle';
import { processValidateCertificate } from '../services/coreProcess';
import moment from 'moment'
import { isMobile } from 'react-device-detect';
import ViewCertificateMobile from '../components/Certificates/ViewCertificateMobile';
moment.locale('es');
const CertificateValidateContainer = props => {
    const {handleOpenSnack} = props
    const theme = useTheme();
    const buttonsClass = buttonsStyles()
    const backgroundsClass = backgroundStyles()
    const [ loading, setLoading ] = useState(false)
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [ certificateData, setCertificateData ] = useState({date: new Date(), code: ''})
    const [ dialog, setDialog ] = useState({
        state: false,
        title: '',
        content: <div></div>
    })
    const doSubmit = () => {
        let user_captcha = document.getElementById('user_captcha_input').value;
        
        if (user_captcha === '') {
            handleOpenSnack('Codigo de validación requerido', 'error')
            return false
        } else {
            const result =validateCaptcha(user_captcha)
            if (result) {
                // handleOpenSnack("")
                loadCaptchaEnginge(4, '#555', '#FFFFFF');
                document.getElementById('user_captcha_input').value = "";
            } else {
                handleOpenSnack('Captcha Incorrecto', 'error')
                document.getElementById('user_captcha_input').value = "";
            }
            return result
        }
    };
    const handleValidateCertificate = (values) => {
        
        const { code, date } = values
        const codeStructure = code.split('-')
        let bodySend = {
            SecuencialEmpresa: 1,
            SecuencialCertificado: codeStructure[2],
            TipoCertificado: codeStructure[1],
            FechaEmision: moment(date, 'YYYY-MM-DD').format()
        }
        //console.log(values, bodySend)
        setLoading(true)
        const captchaValidate = doSubmit()
        if (captchaValidate) {
            processValidateCertificate(bodySend).then( res => {
                //console.log('VALIDACION ', res)
                // setCertificateData({date: moment(), code: ''})
                // handleOpenSnack(res.message, res.type)
                const {FechaCaducidad, FechaEmision, NumeroCliente, Socio, TipoDeCertificado} = res.data
                setDialog({
                    state: true,
                    title: 'Información del certificado',
                    content: (isMobile) ? <ViewCertificateMobile dataCertificate = {res.data} setDialog = {setDialog} /> : <div className = {backgroundsClass.certificateBackground}>
                                <Grid container spacing={1} style={{paddingBottom: 110}}  alignItems="flex-start">
                                    <Grid item xs={11} md={11} sm={11}></Grid>
                                    <Grid item xs={1} md={1} sm={1}>
                                        <IconButton aria-label="close" onClick={() => setDialog({...dialog, state: false, content: <div></div>}) } className = {buttonsClass.closeButton} >
                                            <Icon style={{ color: 'white' }}>close</Icon>
                                        </IconButton>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={3}  alignItems="center" direction="row" justify="center" wrap="nowrap" >
                                <Grid item xs={1} md={1} lg={1} xl={1} >

                                </Grid>
                                <Grid item xs={8} md={8} lg={8} xl={8} >
                                    <Typography variant="body1" gutterBottom style={{fontSize: 15}}  align = 'justify'>
                                        <b style={{color: '#888888'}}>{`Cliente: `}</b>
                                        <span style={{color: '#b1b1b1'}}>{`${NumeroCliente}`}</span>
                                    </Typography>
                                    <Typography variant="body1" gutterBottom style={{fontSize: 15}} align = 'justify'>
                                        <b style={{color: '#888888'}}>{`Nombre: `}</b>
                                        <span style={{color: '#b1b1b1'}}>{`${Socio}`}</span>
                                    </Typography>
                                    <Typography variant="body1" gutterBottom style={{fontSize: 15}} align = 'justify'>
                                        <b style={{color: '#888888'}}>{`Tipo: `}</b>
                                        <span style={{color: '#b1b1b1'}}>{`${TipoDeCertificado}`}</span>
                                    </Typography>
                                    <Typography variant="body1" gutterBottom style={{fontSize: 15}} align = 'justify'>
                                        <b style={{color: '#888888'}}>{`Fecha de emisión: `}</b>
                                        <span style={{color: '#b1b1b1'}}>{`${moment(FechaEmision, 'YYYY-MM-DD').format('LL')}`}</span>
                                    </Typography>
                                    <Typography variant="body1" gutterBottom style={{fontSize: 15}} align = 'justify'>
                                        <b style={{color: '#888888'}}>{`Certificado vigente hasta el `}</b>
                                        <span style={{color: '#b1b1b1'}}>{`${moment(FechaCaducidad, 'YYYY-MM-DD').format('LL')}`}</span>
                                    </Typography>
                                </Grid>
                                <Grid item xs={3} md={3} lg={3} xl={3} >
                                </Grid> 
                            </Grid>
                            </div>
                           
                })
                setLoading(false)
            }).catch(err=> {
                //console.log('err', err)
                handleOpenSnack(err.message, err.type)
                setLoading(false)
            })
        } else {
            setLoading(false)
        }
    }
    const renderBody = () => {
        return  <div>
                    <Grid container spacing={3}>
                        {/* <Grid item xs={12} md={12} lg={12} xl={12}>
                            <img src={process.env.PUBLIC_URL + '/images/bannerwebValidación_Mesa.jpg'} alt="Logo" className={buttonsClass.banner}  />
                        </Grid> */}
                        <Grid item xs={12} md={12} lg={12} xl={12}>
                            <Grid container spacing={1}>
                                <Grid item xs={12} md={12} lg={12} xl={12}>
                                    <Typography variant="body1" gutterBottom>
                                        Los certificados en formato electrónico que emite <b>COOPERATIVA CAJA</b> deben ser validados por la institución o persona que lo solicita.
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={12} lg={12} xl={12}>
                                    <Typography variant="body1" gutterBottom>
                                        <b>IMPORTANTE:</b> Ingrese el Cód. de Certificado ubicado en la parte superior del documento.
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={12} lg={12} xl={12}>
                            <ValidateProcessForm onSubmit = {handleValidateCertificate }  handleOpenSnack = {handleOpenSnack} {...certificateData } setCertificateData = {setCertificateData} />
                        </Grid>
                    </Grid>
                </div>
    }
    return (
        <div>
            <Dashboard
                title= "Dashboard"
                body = { renderBody() }
                multiple = { false }
            />
            <Dialog
                // fullScreen = {false}
                fullScreen={fullScreen}
                maxWidth={'lg'}
                aria-labelledby="simple-dialog-title"
                disableBackdropClick
                disableEscapeKeyDown
                onClose={() => setDialog({...dialog, state: false, content: <div></div>})}
                open={dialog.state} >
                <DialogContent aria-labelledby="simple-dialog-DialogContent">
                {dialog.content}
                </DialogContent>
                {/* <DialogActions>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={12} sm={12}>
                            <Button   variant="contained" onClick={() => setDialog({...dialog, state: false, content: <div></div>})} color="primary" fullWidth>Aceptar</Button>
                        </Grid>
                    </Grid>
                    
                </DialogActions> */}
            </Dialog>
            <LoadingScreen open={loading} />
        </div>
    );
};

CertificateValidateContainer.propTypes = {
    
};

export default CertificateValidateContainer;